<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @reject="reject"
      @export="exportFile"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <RejectedForm
      :visible.sync="rejectedFormOpts.visible"
      :amzPurchaseChangeCode="rejectedFormOpts.amzPurchaseChangeCode"
      @reload="reload"
    />

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-amz-purchase' }"
      :exportOptions="{
        params: { amzPurchaseCode: chooseTemplateOptions.amzPurchaseCode },
        checkUrl: '/ecom/amz/fty/purchase/checkExport',
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import RejectedForm from '../rejected-form'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, RejectedForm, chooseTemplate },
  data() {
    return {
      usePage: true,
      rejectedFormOpts: { visible: false, amzPurchaseChangeCode: '' },
      chooseTemplateOptions: { visible: false, amzPurchaseCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyPurchaseChangeListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query }) {
      this.$router.push({
        name: 'ecom-awsBiz-ftyPurchaseChange-detail',
        params: { pageType, ...params },
        query,
      })
    },
    reject({ amzPurchaseChangeCode }) {
      this.rejectedFormOpts = { amzPurchaseChangeCode, visible: true }
    },
    exportFile({ amzPurchaseCode }) {
      this.chooseTemplateOptions = { visible: true, amzPurchaseCode }
    },
  },
}
</script>
